const hex2decimal = (hexColor) => {
  if (!/^[a-fA-F0-9]+$/.test(hexColor)) {
    throw Error(`Invalid hex string: ${hexColor}`);
  }

  return parseInt(hexColor, 16);
};

export default hex2decimal;
